export default "__VITE_ASSET__CUHlsKM0__"